import LayoutContainer, { LayoutContainerSizes } from 'components/Common/LayoutContainer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

const Root = styled.div`
  &:nth-child(odd) {
    background: ${props => props.theme.palette.neutral.default.six};
  }
`

const PaddedLayoutContainer = styled(LayoutContainer)`
  padding: ${rem(40)} ${rem(20)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(60)} ${rem(20)};
  }
`

interface Props {
  children: React.ReactNode;
  size?: LayoutContainerSizes;
}

function PageSection({ children, size = 'lg' }: Props) {
  return (
    <Root>
      <PaddedLayoutContainer size={size}>
        {children}
      </PaddedLayoutContainer>
    </Root>
  )
}

export default PageSection
